module.exports = __webpack_public_path__ + "static/legends-2-84f98b1809089c5aece9709980126409.jpg";